import { render } from "./Photo.vue?vue&type=template&id=97fb869a&scoped=true"
import script from "./Photo.vue?vue&type=script&lang=js"
export * from "./Photo.vue?vue&type=script&lang=js"
script.render = render
script.__scopeId = "data-v-97fb869a"

export default script